import React, { useState, useRef, useEffect } from "react";
import logo from "../../assets/chatbot.png";
import logo1 from "../../assets/Image (3).jpg";
import {
  MessageCircle,
  Plus,
  Send,
  Menu,
  X,
  Edit2,
  Trash2,
  Bot,
  User,
  Download,
  CheckSquare,
  Square,
  Check,
  RotateCcw,  //added for regenerating icon
  MoreVertical,  // added for menu icon 
  AlertCircle, // added for delete 
  Loader2,
} from "lucide-react";
import axiosClient from "../../api-client/AxiosClient";
import appConfig from '../../config/appConfig';
import { toast } from "react-toastify";
import FeedbackComponent from "../../component/pages/Falcon360/targetMapping/FeedbackComponent"; //import  feedback component 
import "./ChatHistoryMenu.css"; //import custom css for chat history menu
import { validateCorporationData } from "../../utils/dataValidation";

const FalconAIChatbot = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
    // const [userMappingFileId, setUserMappingFileId] = useState(null);

  const [chats, setChats] = useState( [] );
  const [activeChat, setActiveChat] = useState(1);
  const [message, setMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState({});
  const [isTyping, setIsTyping] = useState(false);
  const [mapperFiles, setMapperFiles] = useState([]);
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);
  const [isApproving, setIsApproving] = useState(false);
  const [regeneratingMessageId, setRegeneratingMessageId] = useState(null); //  New regenerating state  
  //  Added state for user ID 
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoadingConversations, setIsLoadingConversations] = useState(true);//added for loading conversations
  const [loadingMessages, setLoadingMessages] = useState(false);//added for loading spinner

  const [selectedCorporation, setSelectedCorporation] = useState({
      label: "",
      value: "",
    });

    // New states for menu functionality
  const [openMenuId, setOpenMenuId] = useState(null);
  const [renamingChatId, setRenamingChatId] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const menuRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chats]);

  // useEffect(() => {
  //   const storedFileId = sessionStorage.getItem('selectedFileId');
  //   if (storedFileId) {
  //     setUserMappingFileId(parseInt(storedFileId));
  //   }
  // }, []);

  useEffect(() => {
  const fetchMapperFiles = async () => {
    try {
      const response = await axiosClient.get("/api/Mapper/GetMapperFiles");
      setMapperFiles(response.data);
      console.log("Mapper files loaded:", response.data);
    } catch (error) {
      console.error("Error fetching mapper files:", error);
      toast.error("Failed to load mapper files");
    }
  };

  fetchMapperFiles();
  }, []);

  
  // Close menu when clicking outside
  useEffect(() => {
    //event handler for mouse clicks
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) { //check if click is outside menu
        setOpenMenuId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside); 
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



// extract current user email from session storage
  const getCurrentUserEmail = () => {
    try {
      const accountKey = JSON.parse(sessionStorage.getItem("msal.account.keys"))?.[0]; //retrieve account key 
      //if account key exists , get account data and extract email
      if (accountKey) {
        const accountData = JSON.parse(sessionStorage.getItem(accountKey));
        return accountData?.username || null; 
      }
      return null; // no account found
    } catch (error) {
      // return null if any error
      return null;
    }
  };

  // Fetch user id by matching email with backend user data
  const fetchCurrentUserId = async () => {
    try {
      const currentUserEmail = getCurrentUserEmail();

      if (!currentUserEmail) {
        return null;
      }

      //console.log("Fetching user ID for:", currentUserEmail);

      const response = await axiosClient.get("/api/User/all"); // fetch all users from backend

      if (!response || !response.data) { // validate response
       
        return null;
      }
       // ensure data is an array
      const allUsers = Array.isArray(response.data) ? response.data : [];
      const normalizedCurrentEmail = currentUserEmail.toLowerCase().trim();

      let matchedUser = allUsers.find(
        (user) => user.email && user.email.toLowerCase().trim() === normalizedCurrentEmail
      );
       // if no exact match, try fuzzy matching
      if (!matchedUser) {
        matchedUser = allUsers.find((user) => {
          if (!user.email) return false; //skip if no email
          const normalizedUserEmail = user.email.toLowerCase().trim();
          return (
            normalizedUserEmail.includes(normalizedCurrentEmail) ||
            normalizedCurrentEmail.includes(normalizedUserEmail)
          );
        });
      }
       //if user found,extract and return user id
      if (matchedUser) {
        const userId = matchedUser.userId || matchedUser.id || null;
        
        return userId;
      }

      return null;
    } catch (error) {
      return null;
    }
  };

  // Get welcome message based on corporation ID
  const getWelcomeMessage = (corporationId) => {
    const corpId = corporationId ? parseInt(corporationId) : null;
    
    switch (corpId) {
      case 1:
        return `👋 Hello!  
I am your **Mapping Assistant**. I can help you with:  
- SAP S/4HANA ➝ AX mapping queries  
- Download results as **CSV**  
Let's get started! 🚀`;
      case 2:
        return `👋 Hello!
The module is currently under development. Will notify you once it becomes available.`;
      case 3:
        return `👋 Hello!
The module is currently under development. Will inform you once it is ready to use.`;
      case 5:
        return `👋 Hello!  
I am your **Mapping Assistant**. I can help you with:  
- DB2 ➝ SAP S/4HANA queries  
- Download results as **CSV**  
Let's get started! 🚀`;
      default:
        return `👋 Hello!  
I am your **Mapping Assistant**. I can help you with:  
- SAP S/4HANA ➝ AX mapping queries  
- Download results as **CSV**  
Let's get started! 🚀`;
    }
  };

  // Load selected corporation from local storage
  useEffect(() => {
    const storedCorporation = localStorage.getItem("selectedCorporation"); //retrieve stored corporation data
    if (storedCorporation) { //if exists, parse and set state
      const parsedCorporation = JSON.parse(storedCorporation);
      setSelectedCorporation(parsedCorporation);
    }
  }, []); // run once on mount

//added to listen for changes in selected corporation
useEffect(() => {
  const handleStorageChange = (e) => {
    if (e.key === "selectedCorporation") {
      try {
        if (e.newValue === null) {
          // Corporation cleared
          setSelectedCorporation({ label: "", value: "" });
          setChats([]);
          setActiveChat(null);
          return;
        }
 
        const parsedCorporation = JSON.parse(e.newValue);
        const validatedCorp = validateCorporationData(parsedCorporation);
       
        // Only update if corporation actually changed
        if (validatedCorp.value !== selectedCorporation.value) {
          setSelectedCorporation(validatedCorp);
         
          // Clear existing chats and reset state
          setChats([]);
          setActiveChat(null);
          setSelectedRows({});
         
          // Create new welcome chat for the new corporation
          const welcomeChat = {
            id: Date.now(),
            title: "New Chat",
            messages: [
              {
                id: Date.now(),
                sender: "ai",
                text: getWelcomeMessage(validatedCorp.value),
                timestamp: new Date(),
                hasDownload: false,
              },
            ],
            isLoaded: true,
          };
         
          setChats([welcomeChat]);
          setActiveChat(welcomeChat.id);
        }
      } catch (error) {
        console.error("Storage change error:", error);
      }
    }
  };
 
  const handleCustomStorageChange = (e) => {
    if (e.detail?.key === "selectedCorporation") {
      try {
        if (e.detail.newValue === null || e.detail.newValue === undefined) {
          // Corporation cleared
          setSelectedCorporation({ label: "", value: "" });
          setChats([]);
          setActiveChat(null);
          return;
        }
 
        // Handle both string and object formats
        let corporationData = e.detail.newValue;
       
        if (typeof corporationData === 'string') {
          try {
            corporationData = JSON.parse(corporationData);
          } catch (parseError) {
            console.error("Failed to parse corporation data:", parseError);
            return;
          }
        }
 
        const validatedCorp = validateCorporationData(corporationData);
       
        // Only update if corporation actually changed
        if (validatedCorp.value !== selectedCorporation.value) {
          setSelectedCorporation(validatedCorp);
         
          // Clear existing chats and reset state
          setChats([]);
          setActiveChat(null);
          setSelectedRows({});
         
          // Create new welcome chat for the new corporation
          const welcomeChat = {
            id: Date.now(),
            title: "New Chat",
            messages: [
              {
                id: Date.now(),
                sender: "ai",
                text: getWelcomeMessage(validatedCorp.value),
                timestamp: new Date(),
                hasDownload: false,
              },
            ],
            isLoaded: true,
          };
         
          setChats([welcomeChat]);
          setActiveChat(welcomeChat.id);
        }
      } catch (error) {
        console.error("Custom storage error:", error);
      }
    }
  };
 
  window.addEventListener("storage", handleStorageChange);
  window.addEventListener("customStorageChange", handleCustomStorageChange);
 
  return () => {
    window.removeEventListener("storage", handleStorageChange);
    window.removeEventListener("customStorageChange", handleCustomStorageChange);
  };
}, [selectedCorporation]);


  // Fetch user ID on component mount
  useEffect(() => {
    const loadUserId = async () => { //async function to load user id
      const userId = await fetchCurrentUserId();
      setCurrentUserId(userId);
    };
    loadUserId();
  }, []); 

  // ==================== CHAT HISTORY API FUNCTIONS ====================

  // Get all conversations for current user from backend
  const fetchAllConversations = async () => {
    try {
      const response = await fetch( //get request with user id and corporation id as query params
        `${appConfig.AGENT_BASE}/conversations?user_id=${currentUserId}&corporation_id=${selectedCorporation.value}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      );
       //check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json(); //parse json response
      const conversationsArray = data.conversations || data;
      return { success: true, data:conversationsArray };
    } catch (error) {
      
      return { success: false, error: error.message, data:[] };
    }
  };

  // Get specific conversation 
  const fetchConversationDetails = async (threadId) => {
    try {
      const response = await fetch(
        `${appConfig.AGENT_BASE}/conversations/${threadId}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Update conversation (rename)
  const updateConversation = async (threadId, title, corporationId) => {
    try {
      const response = await fetch( // put request to update conversation title
        `${appConfig.AGENT_BASE}/conversations/${threadId}?title=${encodeURIComponent(
          title
        )}&corporation_id=${corporationId}`,
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json(); // parse json response
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  // Deletes a conversation from backend
  const deleteConversation = async (threadId) => {
    try {
      const response = await fetch( //delete request for specific thread id
        `${appConfig.AGENT_BASE}/conversations/${threadId}`,
        {
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      
      return { success: false, error: error.message };
    }
  };

  // Load messages for a specific chat
  const loadChatMessages = async (threadId) => {
  if (!threadId) {
    console.warn("No thread ID provided");
    return [];
  }

  // Check if messages are already loaded
  const existingChat = chats.find((chat) => chat.id === threadId);
  if (existingChat && existingChat.messages && existingChat.messages.length > 0) {
    return existingChat.messages; //return existing messages
  }

  try {
    setLoadingMessages(true); //to show loading spinner
    
    const result = await fetchConversationDetails(threadId); //featch conversation from backend

    if (result.success && result.data && result.data.messages) {
      const loadedMessages = [];  //array to store processed messages
      //iterate through each message from backend
      result.data.messages.forEach((msg) => {
        let processedData = null;
        let processedText = msg.content;
        let hasDownloadableData = false;
        let userQuery = null;

       // Process AI messages to extract structured data
       if (msg.role === "assistant") {
        let parsedContent = null;
        let isPlainText = false;
       
        try {
          parsedContent = JSON.parse(msg.content);
        } catch (parseError) {
          isPlainText = true;
          processedText = msg.content;
          hasDownloadableData = false;
          processedData = null;
        }
       
        // Only process if we successfully parsed JSON
        if (!isPlainText && parsedContent) {
          // Extract user query if present
          if (parsedContent.query) {
            userQuery = parsedContent.query;
          }
         
          // Check if response field is a stringified JSON
          if (parsedContent.response && typeof parsedContent.response === "string") {
            try {
              parsedContent.response = JSON.parse(parsedContent.response);
            } catch (e) {
              // Keep as string if parsing fails
            }
          }
         
          //  PRIORITY 1: Check for errors
          if (parsedContent.processing_status === "error") {
            processedText = parsedContent.error_msg || parsedContent.detail || parsedContent.message || "An error occurred";
            hasDownloadableData = false;
            processedData = null;
          }
          else if (parsedContent.response?.detail && typeof parsedContent.response.detail === "string" && !Array.isArray(parsedContent.response.detail)) {
            processedText = parsedContent.response.detail;
            hasDownloadableData = false;
            processedData = null;
          }
         
          //  PRIORITY 2: Direct array response
          else if (Array.isArray(parsedContent.response) && parsedContent.response.length > 0) {
            processedData = parsedContent.response;
            processedText = "Here are the results:";
            hasDownloadableData = true;
          }
         
          //  PRIORITY 3: Response object with array properties
          else if (parsedContent.response && typeof parsedContent.response === "object" && !Array.isArray(parsedContent.response)) {
            const listKeys = ['ax_tables', 'sap_tables', 'tables', 'columns', 'results', 'data', 'mappings', 'source_mappings', 'target_mappings'];
            let foundListData = null;
           
            // Check known keys first
            for (const key of listKeys) {
              if (parsedContent.response[key] && Array.isArray(parsedContent.response[key]) && parsedContent.response[key].length > 0) {
                foundListData = parsedContent.response[key];
                break;
              }
            }
           
            // If not found, check ANY array property
            if (!foundListData) {
              const allKeys = Object.keys(parsedContent.response);
              for (const key of allKeys) {
                if (Array.isArray(parsedContent.response[key]) && parsedContent.response[key].length > 0) {
                  foundListData = parsedContent.response[key];
                  break;
                }
              }
            }
           
            if (foundListData) {
              processedData = foundListData;
              processedText = parsedContent.response.message || "Here are the results:";
              hasDownloadableData = true;
            } else {
              // No arrays - simple message
              processedText = parsedContent.response.message || parsedContent.response.detail || JSON.stringify(parsedContent.response);
              hasDownloadableData = false;
              processedData = null;
            }
          }
         
          //  PRIORITY 4: Top-level array
          else if (Array.isArray(parsedContent) && parsedContent.length > 0) {
            processedData = parsedContent;
            processedText = "Here are the results:";
            hasDownloadableData = true;
          }
         
          //  PRIORITY 5: Check top-level properties for arrays
          else {
            const arrayKeys = Object.keys(parsedContent).filter(
              key => Array.isArray(parsedContent[key]) && parsedContent[key].length > 0
            );
           
            if (arrayKeys.length > 0) {
              processedData = parsedContent[arrayKeys[0]];
              processedText = parsedContent.message || parsedContent.detail || "Here are the results:";
              hasDownloadableData = true;
            } else {
              // No arrays found anywhere
              processedText = parsedContent.message || parsedContent.detail || parsedContent.error_msg || JSON.stringify(parsedContent);
              hasDownloadableData = false;
              processedData = null;
            }
          }
        }

          // If we extracted a user query from the AI response, add it as a separate user message
          if (userQuery || msg.original_query) {
            loadedMessages.push({
              id: `user-${msg.message_id}` || `user-${Date.now()}`, //unique id
              sender: "user",
              text: userQuery || msg.original_query,
              timestamp: new Date(msg.timestamp),
              hasDownload: false,
            });
          }

          // Add the AI response
          loadedMessages.push({
            id: msg.message_id || Date.now(),
            sender: "ai",
            text: processedText,
            timestamp: new Date(msg.timestamp),
            hasDownload: hasDownloadableData,
            originalQuery: userQuery || msg.original_query,
            data: processedData,
              mappingFileId: parsedContent?.mapping_file_id || null, // Add this line

          });
        } else if (msg.role === "user") {
          // Regular user message
          loadedMessages.push({
            id: msg.message_id || Date.now(),
            sender: "user",
            text: msg.content,
            timestamp: new Date(msg.timestamp),
            hasDownload: false,
          });
        }
      });

      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === threadId 
            ? { ...chat, messages: loadedMessages, isLoaded: true } 
            : chat
        )
      );

      setLoadingMessages(false); //hide loading spinner
      return loadedMessages;
    } else {
      console.warn(`No messages found for chat ${threadId}`);
      
      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === threadId 
            ? { ...chat, messages: [], isLoaded: true } 
            : chat
        )
      );
      
      setLoadingMessages(false);
      return [];
    }
  } catch (error) {
    toast.error("Failed to load chat messages");
    setLoadingMessages(false);
    return [];
  }
};
 // Load conversations when user id and corporation are available
useEffect(() => {
  const loadConversations = async () => {
    if (!currentUserId || !selectedCorporation.value) {
     // console.log(" Waiting for user ID and corporation...");
      setIsLoadingConversations(false);
      
      // Create default welcome chat
      const welcomeChat = {
        id: Date.now(),
        title: "New Chat",
        messages: [
          {
            id: Date.now(),
            sender: "ai",
            text: getWelcomeMessage(selectedCorporation.value),
            timestamp: new Date(),
            hasDownload: false,
          },
        ],
        isLoaded: true,
      };
      setChats([welcomeChat]);
      setActiveChat(welcomeChat.id);
      return;
    }

    //fetech conversations from backend
    const result = await fetchAllConversations();

    if (result.success && result.data && result.data.length > 0) {
      console.log(`Processing ${result.data.length} conversations`);
      
      const loadedChats = result.data.map((conv) => ({ // map backend conversations to chat format
        id: conv.thread_id,
        title: conv.title || "New Chat",
        messages: [],
        createdAt: conv.created_at,
        updatedAt: conv.updated_at,
        isLoaded: false,
      }));

      //  CREATE A NEW CHAT and add it at the beginning
      const newChatId = Date.now();
      const newChat = {
        id: newChatId,
        title: "New Chat",
        messages: [
          {
            id: newChatId + 1,
            sender: "ai",
            text: getWelcomeMessage(selectedCorporation.value),
            timestamp: new Date(),
            hasDownload: false,
          },
        ],
        isLoaded: true,
      };

      // Add new chat at the beginning, then all loaded chats
      setChats([newChat, ...loadedChats]);
      
      // Set the new chat as active (so it opens by default)
      setActiveChat(newChatId);
      
      
    } else {
    // no conversations found create default welcome chat
      const welcomeChat = {
        id: Date.now(),
        title: "New Chat",
        messages: [
          {
            id: Date.now(),
            sender: "ai",
            text: getWelcomeMessage(selectedCorporation.value),
            timestamp: new Date(),
            hasDownload: false,
          },
        ],
        isLoaded: true,
      };
      setChats([welcomeChat]);
      setActiveChat(welcomeChat.id);
    }

    setIsLoadingConversations(false);
  };

  loadConversations();
}, [currentUserId, selectedCorporation.value]); //rerun when user id or corporation changes
  // ==================== LOAD MESSAGES WHEN SWITCHING CHATS ====================
useEffect(() => {
  const loadMessagesForActiveChat = async () => {
    if (!activeChat) return;
    const currentChatData = chats.find((chat) => chat.id === activeChat);
    // Only load messages if they haven't been loaded yet
    if (currentChatData && !currentChatData.isLoaded) {
      await loadChatMessages(activeChat);
    } else if (currentChatData && currentChatData.isLoaded) {
    }
  };

  loadMessagesForActiveChat();
}, [activeChat]); // Triggers when active chat changes


  // Loading spinner component
const LoadingSpinner = () => (
  <svg
    className="animate-spin h-3 w-3"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);
  

  // Add this function before handleApproveSelected
const findUserMappingFileId = (objectName) => {
  if (!objectName || !mapperFiles.length) {
    console.warn("No object name or mapper files available");
    return null;
  }

  // Normalize the object name for comparison
  const normalizedObjectName = objectName.toLowerCase().trim().replace(/[\s-_]/g, '');
  
  console.log("Looking for object:", normalizedObjectName);

  // Try exact match first on uploadedObjName
  let match = mapperFiles.find(
    file => file.uploadedObjName && 
    file.uploadedObjName.toLowerCase().trim().replace(/[\s-_]/g, '') === normalizedObjectName
  );

  if (match) {
    console.log("Exact match found:", match);
    return match.userMappingFileId;
  }

  // Try fuzzy match on uploadedObjDescription
  match = mapperFiles.find(file => {
    if (!file.uploadedObjDescription) return false;
    const normalizedDesc = file.uploadedObjDescription.toLowerCase().trim().replace(/[\s-_]/g, '');
    return normalizedDesc.includes(normalizedObjectName) || 
           normalizedObjectName.includes(normalizedDesc);
  });

  if (match) {
    console.log("Fuzzy match found on description:", match);
    return match.userMappingFileId;
  }

  // Try partial match on uploadedObjName
  match = mapperFiles.find(file => {
    if (!file.uploadedObjName) return false;
    const normalizedName = file.uploadedObjName.toLowerCase().trim().replace(/[\s-_]/g, '');
    return normalizedName.includes(normalizedObjectName) || 
           normalizedObjectName.includes(normalizedName);
  });

  if (match) {
    console.log("Partial match found on name:", match);
    return match.userMappingFileId;
  }

  console.warn("No match found for object:", objectName);
  return null;
};
//creates a new chat when click on new chat button
  const createNewChat = () => {
    const newChatId = Date.now();
    const newChat = {
      id: newChatId,
      title: "New Chat",
      messages: [
        // ✅ Also add welcome message for new chat
        {
          id: newChatId + 1,
          sender: "ai",
          text: getWelcomeMessage(selectedCorporation.value),
          timestamp: new Date(),
          hasDownload: false,
        },
      ],
      isLoaded:true,
    };
    setChats([ newChat,...chats]);
    setActiveChat(newChatId);
  };

  // const deleteChat = (chatId) => {
  //   if (chats.length === 1) return; // Don't delete the last chat
  //   const updatedChats = chats.filter((chat) => chat.id !== chatId);
  //   setChats(updatedChats);
  //   if (activeChat === chatId) {
  //     setActiveChat(updatedChats[0].id);
  //   }
  // };

  // New menu handlers
  const toggleMenu = (chatId, e) => {
    e.stopPropagation();
    setOpenMenuId(openMenuId === chatId ? null : chatId);
  };

  const handleRenameClick = (chatId, currentTitle, e) => {
    e.stopPropagation();
    setRenamingChatId(chatId);
    setRenameValue(currentTitle);
    setOpenMenuId(null);
  };

  const handleRenameSubmit = async (chatId) => {
    if (renameValue.trim()) {
      // Update locally first for immediate UI feedback
      setChats(
        chats.map((chat) =>
          chat.id === chatId ? { ...chat, title: renameValue.trim() } : chat
        )
      );

      // Update on backend
      const result = await updateConversation(
        chatId,
        renameValue.trim(),
        selectedCorporation.value
      );

      if (result.success) {
        toast.success("Chat renamed successfully!");
      } else {
        toast.error("Failed to rename chat on server");
        console.error("Rename failed:", result.error);
      }
    }
    setRenamingChatId(null);
    setRenameValue("");
  };

  const handleRenameCancel = () => {
    setRenamingChatId(null);
    setRenameValue("");
  };
   //show delete confirmation modal
  const handleDeleteClick = (chatId, e) => {
    e.stopPropagation();
    setDeleteConfirmId(chatId);
    setOpenMenuId(null);
  };

  //  confirms  backend API
  const handleDeleteConfirm = async () => {
    if (chats.length === 1) {
      toast.warning("Cannot delete the last chat!");
      setDeleteConfirmId(null);
      return;
    }
    // Delete from backend first
    const result = await deleteConversation(deleteConfirmId);

    if (result.success) {
      const updatedChats = chats.filter((chat) => chat.id !== deleteConfirmId); //remove from local state
      setChats(updatedChats);
      
      if (activeChat === deleteConfirmId) {
        setActiveChat(updatedChats[0].id);
        loadChatMessages(updatedChats[0].id);
      }

      toast.success("Chat deleted successfully!");
    } else {
      toast.error("Failed to delete chat");
      
    }

    setDeleteConfirmId(null);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmId(null);
  };


  // 2. ADD THIS NEW FUNCTION (after downloadResponse function, before renderTableFromJSON)
  const handleRowSelect = (messageId, rowIndex) => {
    const key = `${messageId}-${rowIndex}`;
    setSelectedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSelectAll = (messageId, totalRows) => {
    const allSelected = Array.from({ length: totalRows }).every(
      (_, i) => selectedRows[`${messageId}-${i}`]
    );

    const newSelection = { ...selectedRows };
    Array.from({ length: totalRows }).forEach((_, i) => {
      newSelection[`${messageId}-${i}`] = !allSelected;
    });
    setSelectedRows(newSelection);
  };


const handleApproveSelected = async (messageId, selectedData, mappingFileId) => {
  // Prevent multiple simultaneous approvals
  if (isApproving) return;
  
  setIsApproving(true);
  
  try {
    console.log("Approve clicked for message:", messageId);
    console.log("Selected rows data:", selectedData);
    console.log("Using mapping_file_id from response:", mappingFileId);

    // Validate that we have a mapping file ID
    if (!mappingFileId) {
      toast.error("Mapping file ID not found in the response");
      return;
    }

    // Transform selected data to match API schema
    const updateBulkMapperDetailsRequests = selectedData.map((row) => ({
      targetTableName: row.SAPTableName || row["SAP Table Name"] || "",
      targetFieldName: row.SAPColumnName || row["SAP Column Name"] || "",
      sourceTableName: row.AXTableName || row["AX Table Name"] || "",
      sourceFieldName: row.AXColumnName || row["AX Column Name"] || "",
    }));

    const payload = {
      updateBulkMapperDetailsRequests: updateBulkMapperDetailsRequests,
      userMappingFileId: mappingFileId,
    };

    console.log("Sending payload to API:", payload);

    const response = await axiosClient.post(
      "/api/Mapper/UpdateBulkMapperFile",
      payload
    );

    console.log("Update response status:", response.status);

    // Success handling
    toast.success(`✅ Selected mappings approved successfully`);
    console.log("Approval successful");

    // Clear selected rows after successful approval
    setSelectedRows({});
  } catch (error) {
    console.error("Approval Error:", error);
    toast.error(`❌ Failed to approve mappings: ${error.message}`);
  } finally {
    setIsApproving(false);
  }
};

  // ✅ NEW: API integration function
  const callAgentAPI = async (query) => {
    try {
      const response = await fetch(
        `${appConfig.AGENT_BASE}/AgenticAIMapping`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            corporation_id:selectedCorporation.value,
            user_id: currentUserId,
            thread_id:activeChat,
            query: query,
            download_format: "", // Set to null to get JSON response first
            filename: "",
          }),
        }
      );

      // Handle non-OK responses (404, 500, etc.)
      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        
        if (errorData) {
          // Return the error details from the API
          return {
            success: false,
            error: `HTTP error! status: ${response.status}`,
            errorDetails: errorData,
            hasDownloadableData: false,
          };
        }
        
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data,
        hasDownloadableData: true, // Indicate this response can be downloaded
      };
    } catch (error) {
      console.error("API Error:", error);
      return {
        success: false,
        error: error.message,
        hasDownloadableData: false,
      };
    }
  };
  // Add this new function before the downloadResponse function
  const generateFileFromDisplayedData = (messageData, format, filename) => {
    try {
      console.log(
        "generateFileFromDisplayedData called with:",
        messageData,
        format,
        filename
      );

      let tableData = null;

      // Check if messageData is directly an array
      if (Array.isArray(messageData)) {
        tableData = messageData;
      }
      // Check for arrays in the data object dynamically
      else if (messageData && typeof messageData === "object") {
        const dataKeys = Object.keys(messageData);
        console.log("Available keys in messageData:", dataKeys);

        // Look for common array property names first
        const commonArrayKeys = [
          "results",
          "sap_columns",
          "sap_tables",
          "data",
        ];
        for (const key of commonArrayKeys) {
          if (
            messageData[key] &&
            Array.isArray(messageData[key]) &&
            messageData[key].length > 0
          ) {
            tableData = messageData[key];
            console.log(`Found data in ${key}:`, tableData);
            break;
          }
        }

        // If not found, look for any array
        if (!tableData) {
          for (const key of dataKeys) {
            if (
              Array.isArray(messageData[key]) &&
              messageData[key].length > 0
            ) {
              tableData = messageData[key];
              console.log(`Found data in ${key}:`, tableData);
              break;
            }
          }
        }
      }

      if (!tableData || !Array.isArray(tableData) || tableData.length === 0) {
        console.error("No valid array data found:", messageData);
        throw new Error(
          "No valid data to export - no arrays found in the data"
        );
      }

      if (format === "csv") {
        let csvContent;

        // Check if array contains objects or simple values
        if (typeof tableData[0] === "object" && tableData[0] !== null) {
          // Handle array of objects
          const allKeys = [
            ...new Set(tableData.flatMap((item) => Object.keys(item))),
          ];
          console.log("CSV Headers:", allKeys);

          csvContent = [
            allKeys.join(","), // Header row
            ...tableData.map((item) =>
              allKeys
                .map((header) => {
                  const value = item[header] || "";
                  return `"${String(value).replace(/"/g, '""')}"`;
                })
                .join(",")
            ),
          ].join("\n");
        } else {
          // Handle simple array
          csvContent = [
            "Index,Value", // Header row
            ...tableData.map(
              (item, index) =>
                `${index + 1},"${String(item).replace(/"/g, '""')}"`
            ),
          ].join("\n");
        }

        console.log("Generated CSV content length:", csvContent.length);

        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { success: true };
      } else {
        throw new Error("Only CSV format is supported in fallback mode");
      }
    } catch (error) {
      console.error("generateFileFromDisplayedData error:", error);
      return { success: false, error: error.message };
    }
  };

  // ✅ NEW: Download function for AI responses
  const downloadResponse = async (query, format = "csv") => {
    try {
      console.log("Downloading with format:", format, "for query:", query);

      const timestamp = new Date()
        .toISOString()
        .slice(0, 19)
        .replace(/:/g, "-");
      const filename = `mapping_result_${timestamp}`;

      const response = await fetch(
        `${appConfig.AGENT_BASE}/AgenticAIMapping`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: query,
            download_format: format,
            filename: filename,
          }),
        }
      );

      console.log("Download response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Download Error Response:", errorText);
        throw new Error(`Download failed! status: ${response.status}`);
      }

      const contentType = response.headers.get("content-type");
      console.log("Content-Type:", contentType);

      // For CSV format
      if (format === "csv") {
        if (contentType && contentType.includes("application/json")) {
          // If API returns JSON, convert it to CSV
          const jsonData = await response.json();
          console.log("Converting JSON to CSV:", jsonData);

          let tableData = null;

          // Check for different data structures
          if (Array.isArray(jsonData)) {
            tableData = jsonData;
          } else if (jsonData.results && Array.isArray(jsonData.results)) {
            tableData = jsonData.results;
          } else if (
            jsonData.sap_columns &&
            Array.isArray(jsonData.sap_columns)
          ) {
            tableData = jsonData.sap_columns;
          } else {
            // Look for any array in the response
            const arrayKeys = Object.keys(jsonData).filter(
              (key) => Array.isArray(jsonData[key]) && jsonData[key].length > 0
            );
            if (arrayKeys.length > 0) {
              tableData = jsonData[arrayKeys[0]];
            }
          }

          if (!tableData || tableData.length === 0) {
            throw new Error(
              "No valid data found in API response for CSV conversion"
            );
          }

          // Generate CSV content
          const allKeys = [
            ...new Set(tableData.flatMap((item) => Object.keys(item))),
          ];
          const csvContent = [
            allKeys.join(","), // Header row
            ...tableData.map((item) =>
              allKeys
                .map((header) => {
                  const value = item[header] || "";
                  return `"${String(value).replace(/"/g, '""')}"`;
                })
                .join(",")
            ),
          ].join("\n");

          const blob = new Blob([csvContent], { type: "text/csv" });

          // Create and trigger download
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `${filename}.csv`;
          document.body.appendChild(a);
          a.click();

          // Cleanup
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 100);

          return { success: true };
        } else {
          // If API returns actual CSV file
          const csvText = await response.text();
          const blob = new Blob([csvText], { type: "text/csv" });

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.download = `${filename}.csv`;
          document.body.appendChild(a);
          a.click();

          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          }, 100);

          return { success: true };
        }
      }

      return { success: false, error: "Unsupported format" };
    } catch (error) {
      console.error("Download Error Details:", error);
      return {
        success: false,
        error: error.message || "Download failed due to network error",
      };
    }
  };

  const renderTableFromJSON = (data, messageId) => {
    try {
      console.log("renderTableFromJSON received data:", data);

      if (!data) {
        console.log("No data provided");
        return null;
      }

      let tableData = null;
      let tableName = "";

      // ✅ IMPROVED: More dynamic data detection
      if (Array.isArray(data)) {
        // Direct array - most common case for your API
        if (
          data.length > 0 &&
          typeof data[0] === "object" &&
          data[0] !== null
        ) {
          tableData = data;
          tableName = "Results";
        } else {
          // Array of simple values
          tableData = data.map((item, index) => ({
            Index: index + 1,
            Value: item,
          }));
          tableName = "Results";
        }
      } else if (typeof data === "object" && data !== null) {
        // Object response - check for different structures

        // Check for simple message responses first
        if (
          data.message &&
          typeof data.message === "string" &&
          Object.keys(data).length === 1
        ) {
          // Don't render table for simple messages
          return null;
        }

        if (
          data.detail &&
          typeof data.detail === "string" &&
          Object.keys(data).length === 1
        ) {
          // Don't render table for simple detail messages
          return null;
        }

        // Look for array properties in the object
        const arrayKeys = Object.keys(data).filter(
          (key) => Array.isArray(data[key]) && data[key].length > 0
        );

        if (arrayKeys.length > 0) {
          const firstArrayKey = arrayKeys[0];
          const firstArray = data[firstArrayKey];

          // Check if it's an array of objects
          if (
            firstArray[0] &&
            typeof firstArray[0] === "object" &&
            firstArray[0] !== null
          ) {
            tableData = firstArray;
            tableName = firstArrayKey
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase());
          } else {
            // Array of simple values
            tableData = firstArray.map((item, index) => ({
              Index: index + 1,
              [firstArrayKey
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase())]: item,
            }));
            tableName = firstArrayKey
              .replace(/_/g, " ")
              .replace(/\b\w/g, (l) => l.toUpperCase());
          }
        } else {
          // Object with properties but no arrays - convert to key-value table
          const objectKeys = Object.keys(data);
          if (objectKeys.length > 0) {
            tableData = objectKeys.map((key) => ({
              Property: key
                .replace(/_/g, " ")
                .replace(/\b\w/g, (l) => l.toUpperCase()),
              Value:
                typeof data[key] === "object" && data[key] !== null
                  ? JSON.stringify(data[key])
                  : String(data[key] || ""),
            }));
            tableName = "Details";
          }
        }
      }

      // ✅ IMPROVED: Better validation and rendering
      if (!tableData || !Array.isArray(tableData) || tableData.length === 0) {
        console.log("No valid table data found");
        return null;
      }

      // Filter out invalid items
      const validTableData = tableData.filter(
        (item) => item && typeof item === "object" && item !== null
      );

      if (validTableData.length === 0) {
        console.log("No valid table data found after filtering");
        return null;
      }

      // Get all unique keys from the data
      const allKeys = [
        ...new Set(validTableData.flatMap((item) => Object.keys(item))),
      ];

      console.log("Rendering table with headers:", allKeys);
      console.log("Table data:", validTableData);

      return (
        <div 
          className={`mt-3 ${
            allKeys.length <= 4 ? "px-4" : "px-4 w-full overflow-x-auto table-scroll-container"
          }`}
          style={allKeys.length > 4 ? {
            scrollbarWidth: 'thin',
            scrollbarColor: '#cbd5e1 #f1f5f9',
            boxSizing: 'border-box'
          } : {}}
        >
          {tableName && (
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              {tableName}
            </h4>
          )}
          <div className={
            allKeys.length <= 2 
              ? "inline-block w-auto" 
              : allKeys.length <= 4 
                ? "inline-block w-auto" 
                : "block"
          }>
            <table className={`bg-white border border-gray-200 rounded-lg text-xs ${
              allKeys.length <= 4 ? "w-auto table-auto" : "table-auto"
            }`}>
            <thead className="bg-gray-50">
              <tr>
                {/* CHECKBOX HEADER */}
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b whitespace-nowrap w-12">
                  <button
                    onClick={() =>
                      handleSelectAll(messageId, validTableData.length)
                    }
                    className="text-gray-600 hover:text-blue-600 transition-colors"
                    title="Select all"
                  >
                    {Array.from({ length: validTableData.length }).every(
                      (_, i) => selectedRows[`${messageId}-${i}`]
                    ) ? (
                      <CheckSquare className="w-4 h-4 text-blue-600" />
                    ) : (
                      <Square className="w-4 h-4" />
                    )}
                  </button>
                </th>
                {allKeys.map((key, index) => (
                  <th
                    key={index}
                    className="px-2 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b whitespace-nowrap"
                  >
                    {(() => {
                      // Custom mappings for specific cases
                      const headerMappings = {
                        SAPTableName: "SAP Table Name",
                        SAPColumnName: "SAP Column Name",
                        AXTableName: "AX Table Name",
                        AXColumnName: "AX Column Name",
                        ObjectName: "Object Name",
                        Description: "Description",
                        Mandatory: "Mandatory",
                      };

                      // Check if we have a specific mapping first
                      if (headerMappings[key]) {
                        return headerMappings[key];
                      }

                      // Fallback: Insert space only before lowercase-to-uppercase transitions
                      return key.replace(/([a-z])([A-Z])/g, "$1 $2");
                    })()}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {validTableData.map((item, rowIndex) => {
                const rowKey = `${messageId}-${rowIndex}`;
                const isSelected = selectedRows[rowKey];
                return (
                  <tr
                    key={rowIndex}
                    className={`hover:bg-gray-50 ${
                      isSelected ? "bg-blue-50" : ""
                    }`}
                  >
                    {/* CHECKBOX CELL */}
                    <td className="px-3 py-2 text-xs border-b w-12">
                      <button
                        onClick={() => handleRowSelect(messageId, rowIndex)}
                        className="text-gray-600 hover:text-blue-600 transition-colors"
                      >
                        {isSelected ? (
                          <CheckSquare className="w-4 h-4 text-blue-600" />
                        ) : (
                          <Square className="w-4 h-4" />
                        )}
                      </button>
                    </td>
                    {allKeys.map((key, colIndex) => {
                      const value = item[key] || "";
                      const displayValue =
                        typeof value === "object" && value !== null
                          ? JSON.stringify(value)
                          : String(value);

                      return (
                        <td
                          key={colIndex}
                          className="px-2 py-2 text-xs text-gray-900 border-b whitespace-nowrap overflow-hidden text-ellipsis"
                          title={displayValue}
                        >
                          {key.toLowerCase().includes("status") ? (
                            <span
                              className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                displayValue.includes("✅") ||
                                displayValue.toLowerCase().includes("mapped")
                                  ? "bg-green-100 text-green-800"
                                  : displayValue.includes("❌") ||
                                    displayValue
                                      .toLowerCase()
                                      .includes("not mapped")
                                  ? "bg-red-100 text-red-800"
                                  : displayValue.includes("⚠️") ||
                                    displayValue
                                      .toLowerCase()
                                      .includes("partial")
                                  ? "bg-yellow-100 text-yellow-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {displayValue}
                            </span>
                          ) : key.toLowerCase().includes("mandatory") ? (
                            <span
                              className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                                displayValue.toLowerCase() === "yes" ||
                                displayValue.toLowerCase() === "true"
                                  ? "bg-red-100 text-red-800"
                                  : "bg-gray-100 text-gray-800"
                              }`}
                            >
                              {displayValue}
                            </span>
                          ) : (
                            <span
                              className={
                                key.toLowerCase().includes("column") ||
                                key.toLowerCase().includes("table") ||
                                key.toLowerCase().includes("name")
                                  ? "font-medium"
                                  : ""
                              }
                            >
                              {displayValue}
                            </span>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </div>
      );
    } catch (error) {
      console.error("Error in renderTableFromJSON:", error);
      return (
        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">
            Error rendering table data: {error.message}
          </p>
        </div>
      );
    }
  };

  const sendMessage = async () => {
    if (!message.trim()) return;

    const userMessage = {
      id: Date.now(),
      text: message,
      sender: "user",
      timestamp: new Date(),
    };

    const currentQuery = message; // Store current query for API call

    setChats((prevChats) =>
      prevChats.map((chat) =>
        chat.id === activeChat
          ? {
              ...chat,
              messages: [...chat.messages, userMessage],
              title:
                chat.messages.length <= 1
                  ? message.slice(0, 30) + (message.length > 30 ? "..." : "")
                  : chat.title,
            }
          : chat
      )
    );

    setMessage("");
    setIsTyping(true);

    try {
      const apiResult = await callAgentAPI(currentQuery);
      // Handle 404 and other errors with detailed messages from API
      if (!apiResult.success && apiResult.errorDetails) {
        const errorResponse = {
          id: Date.now() + 1,
          text: apiResult.errorDetails.detail || apiResult.errorDetails.message || `Error: ${apiResult.error}`,
          sender: "ai",
          timestamp: new Date(),
          hasDownload: false,
        };

        setChats((prevChats) =>
          prevChats.map((chat) =>
            chat.id === activeChat
              ? { ...chat, messages: [...chat.messages, errorResponse] }
              : chat
          )
        );
        setIsTyping(false);
        return;
      }

      

      if (apiResult.success) {
        let aiResponseData = null;
        let aiResponseText = "";
        let hasDownloadableData = false;

        console.log("API Response Data:", apiResult.data);

        // ✅ IMPROVED: Dynamic response handling
        if (typeof apiResult.data === "string") {
          try {
            // Try to parse as JSON first
            const parsedData = JSON.parse(apiResult.data);
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              aiResponseData = parsedData;
              aiResponseText = "Here are the results:";
              hasDownloadableData = true;
            } else if (parsedData && typeof parsedData === "object") {
              aiResponseData = parsedData;
              aiResponseText =
                parsedData.message ||
                parsedData.detail ||
                "Here are the results:";
              hasDownloadableData = false; // Simple message responses typically don't need download
            } else {
              aiResponseText = apiResult.data;
              hasDownloadableData = false;
            }
          } catch (parseError) {
            // If not JSON, treat as plain text
            aiResponseText = apiResult.data;
            hasDownloadableData = false;
          }
        } else if (Array.isArray(apiResult.data)) {
          // Direct array response - always show as table
          aiResponseData = apiResult.data;
          aiResponseText = "Here are the results:";
          hasDownloadableData = true;
        } else if (apiResult.data && typeof apiResult.data === "object") {
          // Object response - check what type it is
          if (
            apiResult.data.message &&
            typeof apiResult.data.message === "string" &&
            Object.keys(apiResult.data).length === 1
          ) {
            // Simple message response like {"message": "Hello! How can I help you today with AX-SAP data?"}
            aiResponseText = apiResult.data.message;
            hasDownloadableData = false;
          } else if (
            apiResult.data.detail &&
            typeof apiResult.data.detail === "string" &&
            Object.keys(apiResult.data).length === 1
          ) {
            // Simple detail response
            aiResponseText = apiResult.data.detail;
            hasDownloadableData = false;
          } else {
            // Complex object with data - show as table
            aiResponseData = apiResult.data;
            aiResponseText =
              apiResult.data.message ||
              apiResult.data.detail ||
              "Here are the results:";
            hasDownloadableData = true;
          }
        } else {
          // Fallback for any other type
          aiResponseText = apiResult.data
            ? String(apiResult.data)
            : "No results found.";
          hasDownloadableData = false;
        }

        const aiResponse = {
          id: Date.now() + 1,
          text: aiResponseText,
          sender: "ai",
          timestamp: new Date(),
          hasDownload: hasDownloadableData,
          originalQuery: currentQuery,
          data: aiResponseData,
            mappingFileId: apiResult.data?.mapping_file_id || null, // Add this line

        };

        console.log("Final AI Response:", aiResponse);

        setChats((prevChats) =>
          prevChats.map((chat) =>
            chat.id === activeChat
              ? { ...chat, messages: [...chat.messages, aiResponse] }
              : chat
          )
        );
      } else {
        const errorResponse = {
          id: Date.now() + 1,
          text: `I apologize, but I encountered an error while processing your request: ${apiResult.error}. Please try again or contact support if the issue persists.`,
          sender: "ai",
          timestamp: new Date(),
          hasDownload: false,
        };

        setChats((prevChats) =>
          prevChats.map((chat) =>
            chat.id === activeChat
              ? { ...chat, messages: [...chat.messages, errorResponse] }
              : chat
          )
        );
      }
    } catch (error) {
      const errorResponse = {
        id: Date.now() + 1,
        text: `I apologize, but I'm currently unable to process your request due to a technical issue. Please try again later.`,
        sender: "ai",
        timestamp: new Date(),
        hasDownload: false,
      };

      setChats((prevChats) =>
        prevChats.map((chat) =>
          chat.id === activeChat
            ? { ...chat, messages: [...chat.messages, errorResponse] }
            : chat
        )
      );
    } finally {
      setIsTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  // ✅ NEW: Handle download button click
  const handleDownload = async (message, format) => {
    if (!message.originalQuery) return;

    const result = await downloadResponse(message.originalQuery, format);
    if (!result.success) {
      console.log("API download failed, trying fallback method...");

      // Fallback: generate file from displayed data
      if (message.data) {
        const timestamp = new Date()
          .toISOString()
          .slice(0, 19)
          .replace(/:/g, "-");
        const filename = `mapping_result_${timestamp}`;

        const fallbackResult = generateFileFromDisplayedData(
          message.data,
          format,
          filename
        );
        if (!fallbackResult.success) {
          toast.error(
            `Download failed: ${result.error}. Fallback also failed: ${fallbackResult.error}`
          );
        }
      } else {
        toast.error(`Download failed: ${result.error}`);
      }
    }
  };
 
// Add this new function to handle feedback submission
const handleFeedbackSubmit = async (messageId, feedbackData) => {
  console.log('Feedback received:', {
    messageId,
    ...feedbackData
  });
  
  try {    
    // Determine which endpoint to use based on feedback type
    const endpoint = feedbackData.type === 'positive' 
      ? `${appConfig.AGENT_BASE}/feedback/thumbs-up`
      : `${appConfig.AGENT_BASE}/feedback/thumbs-down`;
    
    // Prepare the payload based on feedback type
    let payload;
    
    if (feedbackData.type === 'positive') {
      // Thumbs-up payload
      payload = {
        message_id:messageId, 
        thread_id: activeChat, 
        user_id: currentUserId, 
        feedback_type: "positive",
        rating: feedbackData.rating || 5,
        response_type: "",
        reason: "",
        comment: feedbackData.comment || "",
        severity: "",
        metadata: {
          additionalProp1: {}
        }
      };
    } else {
      // Thumbs-down payload with reason and comment
      payload = {
        message_id:messageId ,
        thread_id:activeChat , 
        user_id:currentUserId , 
        feedback_type: "negative",
        rating: feedbackData.rating || 1,
        response_type: "",
        reason: feedbackData.category || "string",
        comment: feedbackData.comment || "",
        severity: feedbackData.severity || "string",
        metadata: {
          additionalProp1: {}
        }
      };
    }
    // Send feedback to backend using fetch (s API calls in this component)
    const response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    toast.success('Thank you for your feedback!');
  } catch (error) {
    toast.error('Failed to submit feedback. Please try again.');
  }
};

// NEW Regenerate Response Function
  const regenerateResponse = async (query, threadId, corporationId) => {
    try {

      const response = await fetch(
        `${appConfig.AGENT_BASE}/response/regenerate-agentic`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            query: query,
            thread_id: activeChat,
            user_id:currentUserId,
            corporation_id: selectedCorporation.value,
            download_format: "",
            filename: "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data,
        hasDownloadableData: true,
      };
    } catch (error) {
      return {
        success: false,
        error: error.message,
        hasDownloadableData: false,
      };
    }
  };

  //  NEW: Handle Regenerate Click
  const handleRegenerate = async (messageId) => {
    // Prevent multiple regenerations at once
    if (regeneratingMessageId) return;

    const currentChatData = chats.find((chat) => chat.id === activeChat);
    if (!currentChatData) return;

    // Find the AI message and its corresponding user message
    const messageIndex = currentChatData.messages.findIndex(
      (msg) => msg.id === messageId
    );

    if (messageIndex === -1 || messageIndex === 0) return;

    const aiMessage = currentChatData.messages[messageIndex];

    // Ensure it's an AI message and we have the original query
    if (aiMessage.sender !== "ai" || !aiMessage.originalQuery) {
      toast.error("Cannot regenerate this message");
      return;
    }

    setRegeneratingMessageId(messageId);

    try {
      // Call the regenerate API
      const apiResult = await regenerateResponse(
        aiMessage.originalQuery,
        activeChat
      );

      if (apiResult.success) {
        let aiResponseData = null;
        let aiResponseText = "";
        let hasDownloadableData = false;

        // Process response (same logic as sendMessage)
        if (typeof apiResult.data === "string") {
          try {
            const parsedData = JSON.parse(apiResult.data);
            if (Array.isArray(parsedData) && parsedData.length > 0) {
              aiResponseData = parsedData;
              aiResponseText = "Here are the regenerated results:";
              hasDownloadableData = true;
            } else if (parsedData && typeof parsedData === "object") {
              aiResponseData = parsedData;
              aiResponseText =
                parsedData.message ||
                parsedData.detail ||
                "Here are the regenerated results:";
              hasDownloadableData = false;
            } else {
              aiResponseText = apiResult.data;
              hasDownloadableData = false;
            }
          } catch (parseError) {
            aiResponseText = apiResult.data;
            hasDownloadableData = false;
          }
        } else if (Array.isArray(apiResult.data)) {
          aiResponseData = apiResult.data;
          aiResponseText = "Here are the regenerated results:";
          hasDownloadableData = true;
        } else if (apiResult.data && typeof apiResult.data === "object") {
          if (
            apiResult.data.message &&
            typeof apiResult.data.message === "string" &&
            Object.keys(apiResult.data).length === 1
          ) {
            aiResponseText = apiResult.data.message;
            hasDownloadableData = false;
          } else if (
            apiResult.data.detail &&
            typeof apiResult.data.detail === "string" &&
            Object.keys(apiResult.data).length === 1
          ) {
            aiResponseText = apiResult.data.detail;
            hasDownloadableData = false;
          } else {
            aiResponseData = apiResult.data;
            aiResponseText =
              apiResult.data.message ||
              apiResult.data.detail ||
              "Here are the regenerated results:";
            hasDownloadableData = true;
          }
        } else {
          aiResponseText = apiResult.data
            ? String(apiResult.data)
            : "No results found.";
          hasDownloadableData = false;
        }

        // Create new regenerated message
        const regeneratedMessage = {
          id: messageId,
          text: aiResponseText,
          sender: "ai",
          timestamp: new Date(),
          hasDownload: hasDownloadableData,
          originalQuery: aiMessage.originalQuery,
          data: aiResponseData,
          isRegenerated: true,
            mappingFileId: apiResult.data?.mapping_file_id || null, // Add this line

        };

        // Replace the old AI message with the regenerated one
        setChats((prevChats) =>
          prevChats.map((chat) =>
            chat.id === activeChat
              ? {
                  ...chat,
                  messages: chat.messages.map((msg) =>
                    msg.id === messageId ? regeneratedMessage : msg
                  ),
                }
              : chat
          )
        );

        toast.success(" Response regenerated successfully!");
      } else {
        toast.error(`Failed to regenerate: ${apiResult.error}`);
      }
    } catch (error) {
      //console.error("Regeneration error:", error);
      toast.error("An error occurred while regenerating the response");
    } finally {
      setRegeneratingMessageId(null);
    }
  };


  const currentChat = chats.find((chat) => chat.id === activeChat);

  return (
    <>
      <style>{`
        .table-scroll-container::-webkit-scrollbar {
          height: 8px;
        }
        .table-scroll-container::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 4px;
        }
        .table-scroll-container::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .table-scroll-container::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
      <div className="flex bg-gray-50 overflow-x-hidden" style={{ height: "calc(100vh - 140px)" }}>
      {/* Sidebar */}
      <div
        className={`${
          sidebarOpen ? "w-64" : "w-0"
        } transition-all duration-300 bg-white text-gray-800 overflow-hidden flex flex-col`}
        style={{ height: "calc(100vh - 140px)" }}
      >
        <div className="p-4 flex flex-col h-full">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold flex items-center gap-2 text-gray-900">
              <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-white border">
                <img
                  src={logo1}
                  alt="AI Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              BlueGecko AI
            </h2>

            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden text-gray-500 hover:text-gray-800"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* New Chat Button */}
          <button
            onClick={createNewChat}
            className="w-full flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg transition-colors mb-4"
          >
            <Plus className="w-4 h-4" />
            New Chat
          </button>

          {/* Chats List */}
          <div className="space-y-1 flex-1 overflow-y-auto">
            {chats.map((chat) => (
              <div
                key={chat.id}
                className={`chat-history-item ${
                  activeChat === chat.id ? "active" : ""
                }`}
                onClick={() => setActiveChat(chat.id)}
              >
                 <div className="chat-history-content">
                  <MessageCircle className="chat-history-icon" />
                  {renamingChatId === chat.id ? (
                <input
                      type="text"
                      value={renameValue}
                      onChange={(e) => setRenameValue(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleRenameSubmit(chat.id);
                        } else if (e.key === "Escape") {
                          handleRenameCancel();
                        }
                      }}
                      onBlur={() => handleRenameSubmit(chat.id)}
                      className="chat-rename-input"
                      autoFocus
                      onClick={(e) => e.stopPropagation()}
                    />
                  ) : (
                    <span className="chat-history-title">{chat.title}</span>
                  )}
                </div>
                
                <div className="chat-menu-container" ref={openMenuId === chat.id ? menuRef : null}>
                  <button
                    onClick={(e) => toggleMenu(chat.id, e)}
                    className="chat-menu-trigger"
                  >
                    <MoreVertical className="w-4 h-4" />
                  </button>
                  
                  {openMenuId === chat.id && (
                    <div className="chat-menu-dropdown">
                      <button
                        onClick={(e) => handleRenameClick(chat.id, chat.title, e)}
                        className="chat-menu-item"
                      >
                        <Edit2 className="w-4 h-4" />
                        <span>Rename</span>
                      </button>
                      <button
                        onClick={(e) => handleDeleteClick(chat.id, e)}
                        className="chat-menu-item delete"
                      >
                        <Trash2 className="w-4 h-4" />
                        <span>Delete</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      {deleteConfirmId && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
            <div className="flex items-center mb-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-100 flex items-center justify-center">
                <svg
                  className="w-6 h-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                </svg>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Delete chat?
                </h3>
              </div>
            </div>

            <div className="mb-6">
              <p className="text-sm text-gray-500">
                This will delete{" "}
                <span className="font-medium text-gray-700">
                  "{chats.find(c => c.id === deleteConfirmId)?.title}"
                </span>
              </p>
              <p className="text-sm text-gray-500 mt-2">
                This action cannot be undone.
              </p>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={handleDeleteCancel}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                No, Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main Chat Area */}
      <div className="flex-1 flex flex-col min-w-0 overflow-x-hidden">
        {/* Header */}
        <div className="bg-white border-b border-gray-200 p-4 flex items-center justify-between flex-shrink-0 sticky top-0 z-10">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="text-gray-600 hover:text-gray-800 flex items-center justify-center w-8 h-8"
            >
              <Menu className="w-5 h-5" />
            </button>
            <h1 className="text-lg font-semibold text-gray-800 leading-8">
              {currentChat?.title || "Falcon AI Chat"}
            </h1>
          </div>

          {/* Logo */}
          <div className="flex items-center gap-2">
            <img
              src={logo}
              alt="Falcon AI Logo"
              className="w-8 h-8 rounded-full object-cover cursor-pointer"
            />
          </div>
        </div>
{/* Messages */}
<div
  className="flex-1 p-4 space-y-4 overflow-y-auto overflow-x-hidden min-h-0"
  style={{ maxHeight: "calc(100% - 140px)" }}
>
  {loadingMessages ? (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600 mx-auto mb-2" />
        <p className="text-sm text-gray-500">Loading messages...</p>
      </div>
    </div>
  ) : currentChat?.messages && currentChat.messages.length > 0 ? (
    <>
      {currentChat.messages.map((msg) => (
        <div
          key={msg.id}
          className={`flex gap-3 ${
            msg.sender === "user" ? "justify-end" : "justify-start"
          }`}
        >
          {msg.sender === "ai" && (
            <div className="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden">
              <img
                src={logo1}
                alt="AI Logo"
                className="w-full h-full object-cover"
              />
            </div>
          )}
          {(() => {
            // Determine column count for responsive sizing
            let columnCount = 0;
            if (msg.data) {
              if (Array.isArray(msg.data) && msg.data.length > 0) {
                columnCount = Object.keys(msg.data[0] || {}).length;
              } else if (typeof msg.data === 'object' && msg.data !== null) {
                // Check for array properties
                const arrayKeys = Object.keys(msg.data).filter(
                  key => Array.isArray(msg.data[key]) && msg.data[key].length > 0
                );
                if (arrayKeys.length > 0 && msg.data[arrayKeys[0]].length > 0) {
                  columnCount = Object.keys(msg.data[arrayKeys[0]][0] || {}).length;
                }
              }
            }
            
            return (
              <div
                className={`overflow-x-hidden ${
                  msg.sender === "user" 
                    ? "max-w-3xl" 
                    : msg.data 
                      ? columnCount <= 4 
                        ? "inline-block w-auto" 
                        : "w-full max-w-full"
                      : "max-w-5xl"
                }`}
              >
                <div
                  className={`py-2 rounded-lg ${
                    msg.sender === "user"
                      ? "px-4 bg-blue-500 text-white"
                      : msg.data
                        ? columnCount <= 4
                          ? "px-0 bg-white border border-gray-200 text-gray-800"
                          : "px-0 bg-white border border-gray-200 text-gray-800 w-full"
                        : "px-4 bg-white border border-gray-200 text-gray-800"
                  }`}
                >
                  <p className={`whitespace-pre-wrap ${
                    msg.data ? 'px-4' : ''
                  }`}>{msg.text}</p>

                  {/* Render table for AI responses with structured data */}
                  {msg.sender === "ai" &&
                    msg.data &&
                    renderTableFromJSON(msg.data, msg.id)}
                    
                  {msg.timestamp && !isNaN(msg.timestamp.getTime()) && (
                    <span className={`text-xs opacity-70 mt-1 block ${
                      msg.data ? 'px-4' : ''
                    }`}>
                      {msg.timestamp.toLocaleTimeString()}
                    </span>
                  )}
                </div>
                {/* Feedback and Action Buttons for AI Messages */}
                {msg.sender === "ai" && msg.originalQuery && (
              <div className="mt-2 flex items-center gap-1 flex-wrap">
                {/* Feedback Component */}
                <FeedbackComponent 
                  messageId={msg.id}
                  onFeedbackSubmit={handleFeedbackSubmit}
                />
                {/*  NEW: Regenerate Button */}
                <button
                  onClick={() => handleRegenerate(msg.id)}
                  disabled={regeneratingMessageId === msg.id}
                  className={`flex items-center gap-1 px-3 py-1 text-xs rounded-md transition-all ${
                    regeneratingMessageId === msg.id
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                  }`}
                  title="Regenerate response"
                >
                  {regeneratingMessageId === msg.id ? (
                    <>
                      <LoadingSpinner />
                    </>
                  ) : (
                    <>
                      <RotateCcw className="w-3 h-3" />
                    </>
                  )}
                </button>

                {msg.hasDownload && (
                  <button
                    onClick={() => handleDownload(msg, "csv")}
                    className="flex items-center gap-1 px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-all"
                    title="Download CSV"
                  >
                    <Download className="w-3 h-4" />
                  </button>
                )}

                {/* APPROVE BUTTON */}
                {(() => {
                  let actualTableData = null;
                  
                  if (Array.isArray(msg.data)) {
                    actualTableData = msg.data;
                  } else if (msg.data && typeof msg.data === "object") {
                    const arrayKeys = Object.keys(msg.data).filter(
                      (key) => Array.isArray(msg.data[key]) && msg.data[key].length > 0
                    );
                    if (arrayKeys.length > 0) {
                      actualTableData = msg.data[arrayKeys[0]];
                    }
                  }

                  if (!actualTableData || !Array.isArray(actualTableData) || actualTableData.length === 0) {
                    return null;
                  }

                  const selectedIndices = [];
                  actualTableData.forEach((_, index) => {
                    if (selectedRows[`${msg.id}-${index}`]) {
                      selectedIndices.push(index);
                    }
                  });

                  if (selectedIndices.length === 0) {
                    return null;
                  }

                  return (
                    <button
                      onClick={() => {
                        const selectedRowsData = selectedIndices.map(i => actualTableData[i]);
    handleApproveSelected(msg.id, selectedRowsData, msg.mappingFileId); // Pass mappingFileId here
                      }}
                      disabled={isApproving}
                      className={`flex items-center gap-1 px-3 py-1 text-xs text-white rounded-md transition-all ${
                        isApproving 
                          ? 'bg-green-400 cursor-not-allowed' 
                          : 'bg-green-500 hover:bg-green-600'
                      }`}
                    >
                      {isApproving ? (
                        <>
                          <LoadingSpinner />
                          <span>Approving...</span>
                        </>
                      ) : (
                        <>
                          <Check className="w-3 h-3" />
                          <span>Approve Selected ({selectedIndices.length})</span>
                        </>
                      )}
                    </button>
                  );
                })()}
              </div>
            )}
              </div>
            );
          })()}
          {msg.sender === "user" && (
            <div className="w-8 h-8 bg-gray-500 rounded-full flex items-center justify-center flex-shrink-0">
              <User className="w-4 h-4 text-white" />
            </div>
          )}
        </div>
      ))}

      {isTyping && (
        <div className="flex gap-3">
          <div className="w-8 h-8 rounded-full flex-shrink-0 overflow-hidden">
            <img
              src={logo1}
              alt="AI Logo"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="bg-white border border-gray-200 px-4 py-2 rounded-lg">
            <div className="flex gap-1">
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
              <div
                className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                style={{ animationDelay: "0.1s" }}
              ></div>
              <div
                className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
                style={{ animationDelay: "0.2s" }}
              ></div>
            </div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </>
  ) : (
    <div className="flex items-center justify-center h-full text-gray-400">
      <p className="text-sm">No messages yet. Start the conversation!</p>
    </div>
  )}
</div>
        {/* Input Area */}
        <div className="bg-white border-t border-gray-200 px-4 py-1 flex-shrink-0 sticky bottom-0 z-10">
          <div className="max-w-4xl mx-auto ">
            <div className="relative flex items-center">
              <textarea
                ref={textareaRef}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Type your message..."
                className="w-full pr-12 pl-4 py-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                rows="1"
                style={{ minHeight: "48px", maxHeight: "120px" }}
              />
              <button
                onClick={sendMessage}
                disabled={!message.trim() || isTyping}
                className={`absolute right-3 p-2 rounded-md transition-colors ${
                  message.trim() && !isTyping
                    ? "text-blue-500 hover:text-blue-600"
                    : "text-gray-400 cursor-not-allowed"
                }`}
              >
                <Send className="w-5 h-5" />
              </button>
            </div>

            <p className="text-xs text-gray-500  text-center">
              Press Enter to send, Shift + Enter for new line
            </p>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default FalconAIChatbot;
